export const landingFr = {
  "ld.nav_how": "Comment ça marche",
  "ld.nav_examples": "Exemples",
  "ld.nav_fx": "Stickers & sons",
  "ld.nav_platforms": "Plateformes",
  "ld.nav_free": "Offre gratuite",
  "ld.nav_faq": "FAQ",
  "ld.login": "Connexion",
  "ld.open_app": "Ouvrir l'app",
  "ld.demo": "Compte démo",
  "ld.try_free": "Essaie gratuitement · 3 clips offerts",
  "ld.try_nav": "Essai gratuit",
  "ld.formats_hint": "Un seul clip, tous les formats : TikTok, Instagram, YouTube",
  "ld.bub_views": "vues sur TikTok",
  "ld.swipe_hint": "Glisse pour changer de format",
  "ld.bub_ready": "clip prêt à poster",
  "ld.bub_viral": "score viral IA",
  "ld.bub_likes": "likes en 24 h",
  "ld.badge": "IA Gemini 3 · Rendu FFmpeg réel",
  "ld.h1a": "Tes meilleurs moments.",
  "ld.h1b": "Clippés par l'IA.",
  "ld.sub": "Importe une VOD ou branche ton live : CLIP-EX repère tes kills, clutchs et fails, puis exporte tes clips en 9:16, 1:1 ou 16:9 pour TikTok, Reels, Shorts et YouTube — avec stickers 3D animés et sons qui frappent.",
  "ld.cta": "Commencer gratuitement",
  "ld.cta_hint": "3 clips gratuits chaque semaine · sans carte bancaire",
  "ld.stat1": "stickers 3D animés",
  "ld.stat2": "sons de clip",
  "ld.stat4": "musiques libres de droits",
  "ld.stat3": "formats d'export",
  "ld.how_label": "En 3 étapes",
  "ld.how_title": "De la VOD au clip viral en quelques minutes",
  "ld.s1_t": "Importe ou branche ton live",
  "ld.s1_d": "Téléverse une vidéo, colle un lien Twitch, Kick, YouTube ou TikTok, ou connecte OBS.",
  "ld.s2_t": "L'IA trouve les moments forts",
  "ld.s2_d": "Gemini analyse ta partie et détecte headshots, clutchs, fails et moments drôles, avec titres, hooks et hashtags.",
  "ld.s3_t": "Peaufine et exporte",
  "ld.s3_d": "Ajoute effets, stickers animés et sons, ou demande à l'IA de monter pour toi. Export 9:16, 16:9 ou 1:1.",
  "ld.ex_label": "Exemples",
  "ld.ex_title": "À quoi ressemblent tes clips",
  "ld.ex_note": "Aperçus illustratifs — de vrais clips de créateurs arrivent bientôt.",
  "ld.ex_0": "Clutch 1v4 en fin de manche",
  "ld.ex_1": "No scope de l'autre bout de la map",
  "ld.ex_2": "Le fail le plus drôle de la soirée",
  "ld.ex_play": "Rejouer l'aperçu",
  "ld.fx_label": "Stickers & sons",
  "ld.fx_title": "Un pack jamais vu, inclus gratuitement",
  "ld.fx_sub": "30 stickers 3D, 9 animations, ton propre texte stylisé et 30 sons percutants, rendus pour de vrai dans ta vidéo.",
  "ld.fx_custom": "Ton texte",
  "ld.fx_sounds": "Écoute quelques sons",
  "ld.pf_label": "Plateformes",
  "ld.pf_title": "Branché sur ton setup",
  "ld.pf_obs": "Script OBS",
  "ld.free_label": "Offre créateur",
  "ld.free_title": "3 clips gratuits chaque semaine",
  "ld.free_sub": "Pour tous les créateurs, renouvelé automatiquement chaque semaine.",
  "ld.free_f1": "Détection des moments forts par l'IA Gemini",
  "ld.free_f2": "Export HD en 9:16, 16:9 et 1:1",
  "ld.free_f3": "30 stickers 3D animés et 30 sons",
  "ld.free_f4": "Effets réels : zoom, shake, glitch, slow-mo…",
  "ld.free_f5": "Montage par IA en langage naturel",
  "ld.free_cta": "Créer mon compte gratuit",
  "ld.per_week": "clips gratuits / semaine",
  "ld.free_soon": "Besoin de plus ? Forfaits dès 4,99 $ CAD, crédits sans expiration",
  "ld.law25": "Conforme à la Loi 25 (Québec)",
  "ld.free_badge": "Gratuit",
  "ld.perk_credits_t": "Crédits sans abonnement",
  "ld.perk_credits_d": "Besoin de plus de clips ? Achète un forfait de crédits une seule fois, quand tu veux. Aucun renouvellement automatique.",
  "ld.perk_credits_1": "Paiement unique",
  "ld.perk_credits_2": "Sans expiration",
  "ld.perk_credits_3": "Dès 4,99 $ CAD",
  "ld.perk_referral_t": "Invite un ami, +3 clips chacun",
  "ld.perk_referral_d": "Partage ton lien de parrainage : toi et ton ami recevez chacun 3 clips gratuits dès son inscription.",
  "ld.perk_referral_1": "+3 pour toi",
  "ld.perk_referral_2": "+3 pour ton ami",
  "ld.perk_referral_3": "Classement mensuel",
  "ld.faq_label": "FAQ",
  "ld.faq_title": "Questions fréquentes",
  "ld.q0": "Comment fonctionnent les 3 clips gratuits par semaine ?",
  "ld.a0": "Chaque compte reçoit 3 exports gratuits par semaine. Le compteur se remet à zéro automatiquement. L'analyse et l'aperçu restent illimités.",
  "ld.q1": "Quelles plateformes sont supportées ?",
  "ld.a1": "Tu peux téléverser tes vidéos ou importer un lien public Twitch, Kick, YouTube ou TikTok. Pour le live, CLIP-EX propose un script OBS et un auto-clippeur.",
  "ld.q2": "Comment l'IA détecte mes meilleurs moments ?",
  "ld.a2": "Gemini regarde ta vidéo et repère l'action, les réactions et les moments drôles. Tu gardes toujours la main : chaque clip est modifiable.",
  "ld.q3": "Est-ce que je peux publier les sons et stickers ?",
  "ld.a3": "Oui. Les stickers et les sons sont créés pour CLIP-EX et libres de droits pour tes clips.",
  "ld.q4": "Mes données sont-elles protégées ?",
  "ld.a4": "CLIP-EX respecte la Loi 25 du Québec : consentement explicite, accès, rectification et suppression de tes données à tout moment.",
  "ld.final_title": "Ton prochain clip viral est déjà dans ta VOD.",
  "ld.final_cta": "Je me lance",
  "sh.share": "Lien public",
  "vt.sort_recent": "Plus récents",
  "vt.sort_reactions": "Plus de réactions",
  "vt.sort_views": "Plus vus",
  "pf.followers": "Abonnés",
  "pf.view_creator": "Voir le profil",
  "fl.copy": "Copier le lien du profil",
  "fl.copied": "Lien du profil copié : colle-le sur Discord ou X pour afficher la carte",
  "fl.title": "Suivre {name}",
  "fl.desc": "Reçois un courriel quand ce créateur partage un nouveau clip (1 par jour maximum).",
  "fl.email_ph": "ton@courriel.com",
  "fl.follow": "Suivre",
  "fl.invalid_link": "Ce lien est invalide ou a déjà été utilisé.",
  "fl.legal": "Tu devras confirmer par courriel. Désabonnement en un clic dans chaque courriel. Ton adresse n'est jamais partagée.",
  "fl.sent": "Presque fini ! Clique sur le lien envoyé à {email} pour confirmer ton abonnement.",
  "fl.confirmed": "C'est confirmé : tu suis maintenant {name} !",
  "fl.unsubscribed": "Tu es désabonné. Tu ne recevras plus de courriels pour ce créateur.",
  "pf.missing": "Ce profil n'existe pas ou n'est pas public.",
  "pf.this_month": "ce mois-ci",
  "pf.clips": "Clips partagés",
  "pf.views": "Vues totales",
  "pf.month_views": "Vues ce mois",
  "pf.reactions": "Réactions",
  "pf.no_clips": "Aucun clip partagé pour l'instant.",
  "pf.edit_title": "Profil public de créateur",
  "pf.edit_desc": "Active ta page publique clip-ex.ca/u/ton-pseudo avec tes clips partagés, tes badges et tes liens.",
  "pf.handle": "Pseudo (adresse du profil)",
  "pf.display": "Nom affiché",
  "pf.bio": "Bio (200 caractères max)",
  "pf.link_ph": "Pseudo ou lien de ta chaîne",
  "pf.consent": "En activant ton profil, ton nom affiché, ta bio, tes liens et tes clips partagés deviennent publics. Tu peux le désactiver à tout moment (Loi 25).",
  "pf.save": "Enregistrer le profil",
  "pf.saved": "Profil enregistré",
  "pf.view": "Voir mon profil",
  "rk.ranked": "Bravo ! Télécharge ton badge et publie-le sur tes réseaux.",
  "rk.unranked": "Pas encore dans le top 10 ce mois-ci : partage tes clips pour grimper au classement et débloquer ton badge partageable.",
  "rk.square": "Carré 1080×1080",
  "rk.story": "Story 1080×1920",
  "vt.nav": "Vitrine",
  "tf.nav": "Tarifs",
  "tf.label": "Tarifs",
  "tf.title": "Simple. Sans abonnement.",
  "tf.how": "Chaque semaine, tu reçois 3 clips gratuits, renouvelés automatiquement. Besoin de plus ? Achète un forfait de crédits en un seul paiement : 1 crédit = 1 clip IA. Tes crédits sont ajoutés dès que le paiement est confirmé, n'expirent jamais et sont utilisés automatiquement après tes clips gratuits. Aucun renouvellement, aucune surprise — tu rachètes seulement quand tu veux.",
  "tf.pt1": "3 clips gratuits / semaine",
  "tf.pt2": "1 crédit = 1 clip",
  "tf.pt3": "Crédits sans expiration",
  "tf.pt4": "+3 clips par ami invité",
  "tf.popular": "Populaire",
  "tf.name_free": "Gratuit",
  "tf.name_small": "Starter",
  "tf.name_medium": "Créateur",
  "tf.name_large": "Pro",
  "tf.per_week": "clips / semaine",
  "tf.clips": "clips",
  "tf.free_price": "0 $",
  "tf.free_note": "Renouvelé chaque semaine",
  "tf.once": "paiement unique",
  "tf.free_f1": "Détection IA des moments forts",
  "tf.free_f2": "Export 9:16, 1:1 et 16:9",
  "tf.free_f3": "Stickers 3D et sons inclus",
  "tf.paid_f1": "Toute l'offre gratuite",
  "tf.paid_f2": "Crédits qui n'expirent jamais",
  "tf.paid_f3": "Aucun abonnement ni renouvellement",
  "tf.cta_free": "Commencer gratuitement",
  "tf.cta_buy": "Acheter ce forfait",
  "tf.tax": "Prix en dollars canadiens. Taxes applicables calculées au paiement sécurisé.",
  "vt.label": "Vitrine CLIP-EX",
  "vt.title1": "Les meilleurs clips ",
  "vt.title2": "de la commu",
  "vt.sub": "Des moments approuvés par l'équipe CLIP-EX, créés par de vrais streamers et gamers. Filtre par jeu et grimpe au classement du mois.",
  "vt.all": "Tous les jeux",
  "vt.empty": "Aucun clip pour ce jeu pour l'instant.",
  "vt.see_all": "Voir toute la vitrine",
  "lb.title": "Classement du mois",
  "lb.empty": "Le classement démarre dès les premières vues de clips partagés ce mois-ci.",
  "lb.how": "Classement selon les vues des clips partagés pendant le mois en cours. Les badges Top 1, Top 3 et Top 10 apparaissent sur les clips des créateurs classés.",
  "lb.badge_top1": "Top 1",
  "lb.badge_top3": "Top 3",
  "lb.badge_top10": "Top 10",
  "pref.bonus_title": "Courriel « clip bonus gagné »",
  "pref.bonus_desc": "Reçois un courriel quand un créateur inscrit grâce à toi te fait gagner un clip bonus.",
  "pref.saved": "Préférence enregistrée",
  "pref.news_title": "Courriel des nouveautés",
  "pref.news_desc": "Reçois un courriel avec les principales nouveautés de chaque version de CLIP-EX.",
  "nav.stats": "Statistiques",
  "stt.label": "Statistiques de partage",
  "stt.title1": "Tes clips ",
  "stt.title2": "rapportent",
  "stt.sub": "Vues de tes liens publics, créateurs inscrits grâce à toi et clips bonus gagnés.",
  "stt.views": "Vues totales",
  "stt.signups": "Nouveaux inscrits",
  "stt.pending": "en attente du 1er clip",
  "stt.bonus": "Clips bonus gagnés",
  "stt.this_month": "ces 30 derniers jours",
  "stt.balance": "Clips bonus disponibles",
  "stt.how": "Chaque personne qui s'inscrit via un de tes liens publics, puis exporte son premier clip, te rapporte 1 clip bonus (jusqu'à 10 par mois). Les clips bonus n'expirent pas et s'ajoutent à tes 3 clips gratuits de la semaine.",
  "stt.per_clip": "Détail par clip",
  "stt.empty": "Aucun clip partagé pour l'instant. Active « Lien public » sur un clip de ta bibliothèque.",
  "stt.public": "Public",
  "stt.private": "Privé",
  "stt.open": "Ouvrir",
  "stt.feat_none": "—",
  "stt.feat_pending": "Vitrine : en attente",
  "stt.feat_approved": "Dans la vitrine",
  "stt.feat_rejected": "Vitrine : refusé",
  "sh.feature": "Proposer pour la vitrine de la page d'accueil",
  "sh.feat_consent": "En proposant ce clip, tu confirmes en détenir les droits et acceptes qu'il soit affiché publiquement sur la page d'accueil de CLIP-EX. Tu peux le retirer à tout moment.",
  "sh.feat_sent": "Clip proposé ! Il apparaîtra après validation.",
  "adm.tab_gallery": "Vitrine",
  "adm.gal_intro": "Clips proposés par les créateurs pour la vitrine de la page d'accueil. Seuls les clips approuvés et toujours publics s'affichent (6 max, les plus récents).",
  "adm.gal_empty": "Rien ici pour l'instant.",
  "adm.gal_approve": "Approuver",
  "adm.gal_reject": "Refuser",
  "adm.gal_approved_done": "Clip ajouté à la vitrine",
  "adm.gal_rejected_done": "Clip refusé",
  "adm.gal_pending_done": "Remis en attente",
  "ld.gal_title": "La vitrine des créateurs",
  "ld.gal_sub": "De vrais clips créés avec CLIP-EX par la communauté.",
  "ld.gal_by": "par",
  "sh.copy": "Copier le lien",
  "sh.copied": "Lien de partage copié !",
  "sh.views": "vues",
  "sh.missing": "Ce clip n'est plus partagé.",
  "sh.discover": "Découvrir CLIP-EX",
  "sh.made_with": "Créé avec CLIP-EX",
  "sh.pitch": "Toi aussi, transforme tes parties en clips viraux grâce à l'IA.",
  "sh.cta": "Créer mes clips gratuitement",
  "auth.forgot": "Mot de passe oublié ?",
  "fp.title": "Mot de passe oublié",
  "fp.sub": "Entre ton espace de travail et ton courriel. Si un compte correspond, tu recevras un lien valable 1 heure.",
  "fp.send": "Envoyer le lien",
  "fp.sent_t": "Vérifie ta boîte de réception",
  "fp.sent": "Si un compte correspond, un courriel vient de partir. Pense à regarder tes indésirables.",
  "fp.back": "Retour à la connexion",
  "rp.title": "Nouveau mot de passe",
  "rp.sub": "Choisis un mot de passe d'au moins 8 caractères. Toutes tes sessions ouvertes seront déconnectées.",
  "rp.pw": "Nouveau mot de passe",
  "rp.pw2": "Confirme le mot de passe",
  "rp.mismatch": "Les deux mots de passe ne correspondent pas.",
  "rp.save": "Enregistrer",
  "rp.done": "Mot de passe modifié. Tu peux te connecter.",
  "rp.invalid": "Lien manquant ou invalide.",
};

export const landingEn = {
  "ld.nav_how": "How it works",
  "ld.nav_examples": "Examples",
  "ld.nav_fx": "Stickers & sounds",
  "ld.nav_platforms": "Platforms",
  "ld.nav_free": "Free plan",
  "ld.nav_faq": "FAQ",
  "ld.login": "Log in",
  "ld.open_app": "Open the app",
  "ld.demo": "Demo account",
  "ld.try_free": "Try it free · 3 clips on us",
  "ld.try_nav": "Free trial",
  "ld.formats_hint": "One clip, every format: TikTok, Instagram, YouTube",
  "ld.bub_views": "views on TikTok",
  "ld.swipe_hint": "Swipe to change format",
  "ld.bub_ready": "clip ready to post",
  "ld.bub_viral": "AI viral score",
  "ld.bub_likes": "likes in 24 h",
  "ld.badge": "Gemini 3 AI · Real FFmpeg rendering",
  "ld.h1a": "Your best moments.",
  "ld.h1b": "Clipped by AI.",
  "ld.sub": "Import a VOD or plug in your live: CLIP-EX finds your kills, clutches and fails, then exports your clips in 9:16, 1:1 or 16:9 for TikTok, Reels, Shorts and YouTube — with animated 3D stickers and sounds that hit.",
  "ld.cta": "Start for free",
  "ld.cta_hint": "3 free clips every week · no credit card",
  "ld.stat1": "animated 3D stickers",
  "ld.stat2": "clip sounds",
  "ld.stat4": "royalty-free tracks",
  "ld.stat3": "export formats",
  "ld.how_label": "3 steps",
  "ld.how_title": "From VOD to viral clip in minutes",
  "ld.s1_t": "Import or plug in your live",
  "ld.s1_d": "Upload a video, paste a Twitch, Kick, YouTube or TikTok link, or connect OBS.",
  "ld.s2_t": "AI finds the highlights",
  "ld.s2_d": "Gemini analyzes your match and spots headshots, clutches, fails and funny moments, with titles, hooks and hashtags.",
  "ld.s3_t": "Polish and export",
  "ld.s3_d": "Add effects, animated stickers and sounds, or let the AI edit for you. Export 9:16, 16:9 or 1:1.",
  "ld.ex_label": "Examples",
  "ld.ex_title": "What your clips look like",
  "ld.ex_note": "Illustrative previews — real creator clips coming soon.",
  "ld.ex_0": "1v4 clutch to close the round",
  "ld.ex_1": "No scope across the map",
  "ld.ex_2": "Funniest fail of the night",
  "ld.ex_play": "Replay preview",
  "ld.fx_label": "Stickers & sounds",
  "ld.fx_title": "A never-seen pack, included for free",
  "ld.fx_sub": "30 3D stickers, 9 animations, your own styled text and 30 punchy sounds, truly rendered into your video.",
  "ld.fx_custom": "Your text",
  "ld.fx_sounds": "Hear a few sounds",
  "ld.pf_label": "Platforms",
  "ld.pf_title": "Plugged into your setup",
  "ld.pf_obs": "OBS script",
  "ld.free_label": "Creator plan",
  "ld.free_title": "3 free clips every week",
  "ld.free_sub": "For every creator, renewed automatically each week.",
  "ld.free_f1": "Gemini AI highlight detection",
  "ld.free_f2": "HD export in 9:16, 16:9 and 1:1",
  "ld.free_f3": "30 animated 3D stickers and 30 sounds",
  "ld.free_f4": "Real effects: zoom, shake, glitch, slow-mo…",
  "ld.free_f5": "AI editing in plain language",
  "ld.free_cta": "Create my free account",
  "ld.per_week": "free clips / week",
  "ld.free_soon": "Need more? Packs from $4.99 CAD, credits never expire",
  "ld.law25": "Quebec Law 25 compliant",
  "ld.free_badge": "Free",
  "ld.perk_credits_t": "Credits, no subscription",
  "ld.perk_credits_d": "Need more clips? Buy a credit pack once, whenever you want. No automatic renewal.",
  "ld.perk_credits_1": "One-time payment",
  "ld.perk_credits_2": "Never expire",
  "ld.perk_credits_3": "From $4.99 CAD",
  "ld.perk_referral_t": "Invite a friend, +3 clips each",
  "ld.perk_referral_d": "Share your referral link: you and your friend each get 3 free clips as soon as they sign up.",
  "ld.perk_referral_1": "+3 for you",
  "ld.perk_referral_2": "+3 for your friend",
  "ld.perk_referral_3": "Monthly leaderboard",
  "ld.faq_label": "FAQ",
  "ld.faq_title": "Frequently asked questions",
  "ld.q0": "How do the 3 free clips per week work?",
  "ld.a0": "Every account gets 3 free exports per week. The counter resets automatically. Analysis and previews stay unlimited.",
  "ld.q1": "Which platforms are supported?",
  "ld.a1": "Upload your videos or import a public Twitch, Kick, YouTube or TikTok link. For live, CLIP-EX offers an OBS script and an auto-clipper.",
  "ld.q2": "How does the AI find my best moments?",
  "ld.a2": "Gemini watches your video and spots action, reactions and funny moments. You stay in control: every clip is editable.",
  "ld.q3": "Can I publish the sounds and stickers?",
  "ld.a3": "Yes. Stickers and sounds are made for CLIP-EX and royalty-free for your clips.",
  "ld.q4": "Is my data protected?",
  "ld.a4": "CLIP-EX follows Quebec's Law 25: explicit consent, access, correction and deletion of your data at any time.",
  "ld.final_title": "Your next viral clip is already in your VOD.",
  "ld.final_cta": "Let's go",
  "sh.share": "Public link",
  "vt.sort_recent": "Most recent",
  "vt.sort_reactions": "Most reactions",
  "vt.sort_views": "Most viewed",
  "pf.followers": "Followers",
  "pf.view_creator": "View profile",
  "fl.copy": "Copy profile link",
  "fl.copied": "Profile link copied: paste it on Discord or X to show the card",
  "fl.title": "Follow {name}",
  "fl.desc": "Get an email when this creator shares a new clip (1 per day max).",
  "fl.email_ph": "you@email.com",
  "fl.follow": "Follow",
  "fl.invalid_link": "This link is invalid or has already been used.",
  "fl.legal": "You'll confirm by email. One-click unsubscribe in every email. Your address is never shared.",
  "fl.sent": "Almost done! Click the link sent to {email} to confirm your subscription.",
  "fl.confirmed": "Confirmed: you now follow {name}!",
  "fl.unsubscribed": "You're unsubscribed. You won't get emails for this creator anymore.",
  "pf.missing": "This profile doesn't exist or isn't public.",
  "pf.this_month": "this month",
  "pf.clips": "Shared clips",
  "pf.views": "Total views",
  "pf.month_views": "Views this month",
  "pf.reactions": "Reactions",
  "pf.no_clips": "No shared clips yet.",
  "pf.edit_title": "Public creator profile",
  "pf.edit_desc": "Turn on your public page clip-ex.ca/u/your-handle with your shared clips, badges and links.",
  "pf.handle": "Handle (profile address)",
  "pf.display": "Display name",
  "pf.bio": "Bio (200 characters max)",
  "pf.link_ph": "Channel handle or link",
  "pf.consent": "When your profile is on, your display name, bio, links and shared clips become public. You can turn it off anytime.",
  "pf.save": "Save profile",
  "pf.saved": "Profile saved",
  "pf.view": "View my profile",
  "rk.ranked": "Congrats! Download your badge and post it on your socials.",
  "rk.unranked": "Not in the top 10 yet this month: share your clips to climb the leaderboard and unlock your shareable badge.",
  "rk.square": "Square 1080×1080",
  "rk.story": "Story 1080×1920",
  "vt.nav": "Showcase",
  "tf.nav": "Pricing",
  "tf.label": "Pricing",
  "tf.title": "Simple. No subscription.",
  "tf.how": "Every week you get 3 free clips, renewed automatically. Need more? Buy a credit pack with a single payment: 1 credit = 1 AI clip. Credits are added as soon as payment is confirmed, never expire, and are used automatically after your free clips. No renewal, no surprises — you only buy again when you want.",
  "tf.pt1": "3 free clips / week",
  "tf.pt2": "1 credit = 1 clip",
  "tf.pt3": "Credits never expire",
  "tf.pt4": "+3 clips per invited friend",
  "tf.popular": "Popular",
  "tf.name_free": "Free",
  "tf.name_small": "Starter",
  "tf.name_medium": "Creator",
  "tf.name_large": "Pro",
  "tf.per_week": "clips / week",
  "tf.clips": "clips",
  "tf.free_price": "$0",
  "tf.free_note": "Renewed every week",
  "tf.once": "one-time payment",
  "tf.free_f1": "AI highlight detection",
  "tf.free_f2": "Export 9:16, 1:1 and 16:9",
  "tf.free_f3": "3D stickers and sounds included",
  "tf.paid_f1": "Everything in Free",
  "tf.paid_f2": "Credits that never expire",
  "tf.paid_f3": "No subscription or renewal",
  "tf.cta_free": "Start for free",
  "tf.cta_buy": "Buy this pack",
  "tf.tax": "Prices in Canadian dollars. Applicable taxes calculated at secure checkout.",
  "vt.label": "CLIP-EX showcase",
  "vt.title1": "The community's ",
  "vt.title2": "best clips",
  "vt.sub": "Moments approved by the CLIP-EX team, made by real streamers and gamers. Filter by game and climb this month's leaderboard.",
  "vt.all": "All games",
  "vt.empty": "No clips for this game yet.",
  "vt.see_all": "See the full showcase",
  "lb.title": "Monthly leaderboard",
  "lb.empty": "The leaderboard starts with the first views on shared clips this month.",
  "lb.how": "Ranked by views on shared clips during the current month. Top 1, Top 3 and Top 10 badges appear on ranked creators' clips.",
  "lb.badge_top1": "Top 1",
  "lb.badge_top3": "Top 3",
  "lb.badge_top10": "Top 10",
  "pref.bonus_title": "“Bonus clip earned” email",
  "pref.bonus_desc": "Get an email when a creator who joined through you earns you a bonus clip.",
  "pref.saved": "Preference saved",
  "pref.news_title": "What's new email",
  "pref.news_desc": "Get an email with the main new features of each CLIP-EX version.",
  "nav.stats": "Stats",
  "stt.label": "Sharing stats",
  "stt.title1": "Your clips ",
  "stt.title2": "pay off",
  "stt.sub": "Views on your public links, creators who joined thanks to you and bonus clips earned.",
  "stt.views": "Total views",
  "stt.signups": "New sign-ups",
  "stt.pending": "waiting for their 1st clip",
  "stt.bonus": "Bonus clips earned",
  "stt.this_month": "last 30 days",
  "stt.balance": "Bonus clips available",
  "stt.how": "Each person who signs up through one of your public links and exports their first clip earns you 1 bonus clip (up to 10 per month). Bonus clips never expire and add to your 3 free clips per week.",
  "stt.per_clip": "Per clip",
  "stt.empty": "No shared clips yet. Turn on “Public link” on a clip in your library.",
  "stt.public": "Public",
  "stt.private": "Private",
  "stt.open": "Open",
  "stt.feat_none": "—",
  "stt.feat_pending": "Showcase: pending",
  "stt.feat_approved": "In showcase",
  "stt.feat_rejected": "Showcase: declined",
  "sh.feature": "Submit to the homepage showcase",
  "sh.feat_consent": "By submitting this clip you confirm you own the rights and agree it may be shown publicly on the CLIP-EX homepage. You can withdraw it anytime.",
  "sh.feat_sent": "Clip submitted! It will appear once approved.",
  "adm.tab_gallery": "Showcase",
  "adm.gal_intro": "Clips submitted by creators for the homepage showcase. Only approved clips that are still public are shown (max 6, most recent).",
  "adm.gal_empty": "Nothing here yet.",
  "adm.gal_approve": "Approve",
  "adm.gal_reject": "Decline",
  "adm.gal_approved_done": "Clip added to showcase",
  "adm.gal_rejected_done": "Clip declined",
  "adm.gal_pending_done": "Back to pending",
  "ld.gal_title": "Creator showcase",
  "ld.gal_sub": "Real clips made with CLIP-EX by the community.",
  "ld.gal_by": "by",
  "sh.copy": "Copy link",
  "sh.copied": "Share link copied!",
  "sh.views": "views",
  "sh.missing": "This clip is no longer shared.",
  "sh.discover": "Discover CLIP-EX",
  "sh.made_with": "Made with CLIP-EX",
  "sh.pitch": "Turn your own matches into viral clips with AI.",
  "sh.cta": "Create my clips for free",
  "auth.forgot": "Forgot password?",
  "fp.title": "Forgot password",
  "fp.sub": "Enter your workspace and email. If an account matches, you'll get a link valid for 1 hour.",
  "fp.send": "Send the link",
  "fp.sent_t": "Check your inbox",
  "fp.sent": "If an account matches, an email is on its way. Check your spam folder too.",
  "fp.back": "Back to login",
  "rp.title": "New password",
  "rp.sub": "Choose a password with at least 8 characters. All your open sessions will be signed out.",
  "rp.pw": "New password",
  "rp.pw2": "Confirm password",
  "rp.mismatch": "The two passwords don't match.",
  "rp.save": "Save",
  "rp.done": "Password changed. You can log in now.",
  "rp.invalid": "Missing or invalid link.",
};
